<template>
    <div class="total-pending-cases">
        <b-card no-body>
            <b-card-header class="border-0 px-3 py-2">
                <b-row align-v="center">
                    <b-col cols="9">
                        <h3 class="mb-0">
                            Total Pending Cases
                        </h3>
                    </b-col>
                    <b-col cols="3">
                        <el-select v-model="sort_by" placeholder="Filter by Status">
                            <el-option value="Pending">Pending</el-option>
                            <el-option value="Not Issued">Not Issued</el-option>
                        </el-select>
                    </b-col>
                </b-row>
            </b-card-header>
            <div v-if="tableData.length > 0" class="card-table rounded-bottom">
                <el-table
                :data="tableData"
                show-index
                style="width: 100%">
                    <el-table-column
                        type="index"
                        label="#"
                        min-width="20"
                        width="auto"
                    ></el-table-column>

                    <!-- <el-table-column
                        prop="product_details"
                        label="Product Details"
                        min-width="160"
                        width="auto"
                    >
                        <template slot-scope="scope">
                            <span class="name text-primary">{{ scope.row.product_details }}</span>
                        </template>
                    </el-table-column> -->

                    <el-table-column
                        prop="comms_payout_summary_id"
                        label="Comms Payout Summary ID"
                        min-width="100"
                        width="auto"
                    >
                        <template slot-scope="scope">
                            <a href="#" @click.prevent="openView(scope.row)">
                                #<span class="name text-primary">{{ scope.row.comms_payout_summary_id }}</span>
                            </a>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="sales"
                        label="Pre Sales (RM)"
                        min-width="130"
                        width="auto"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.cps_develop_nett_price | moneyFormatter }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="commission"
                        label="Comm.(%)"
                        min-width="130"
                        width="auto"
                    >
                        <template slot-scope="scope">
                            <span class="name text-primary">{{ scope.row.cps_service_type_percentage }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="pre_rev"
                        label="Pre Rev.(RM)"
                        min-width="150"
                        width="auto"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.cps_total_revenue_point | moneyFormatter }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="status"
                        label="Status"
                        min-width="150"
                        width="auto"
                    >
                        <template slot-scope="scope">
                            <b-badge pill :variant="getStatusVariant(scope)">
                                {{scope.row.approval_status}}
                            </b-badge>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="member"
                        label="Member"
                        min-width="150"
                        width="auto"
                    >
                        <template slot-scope="scope" v-if="scope.row.case_recognize">
                            <span class="name">{{ scope.row.case_recognize.user.name }}</span>
                        </template>
                    </el-table-column>

                    <!-- <el-table-column
                        min-width="140"
                        width="auto"
                    >
                        <template>
                            <b-button variant="primary" class="font-size-small">Approved</b-button>
                        </template>
                    </el-table-column> -->
                </el-table>
                <div class="py-2 px-3">
                    <b-link href="#">View All</b-link>
                </div>
            </div>

            <!--Direct Payout Detail modal-->
            <PayoutDetailsModal 
                :showDirectPayoutDetails.sync="modals.showDirectPayoutDetails" 
                :current_comms_payout_summaries="current_view"
                :comms_payout_summaries="comms_payout_summaries"
                @close-modal="modals.showDirectPayoutDetails=false"
                :decide_mode="decide_mode"
                :permission="permission"
            />
        </b-card>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from 'element-ui'
import { notifyFunctionMixin,axios,services,getHeader,swal } from '@/assets/js/httpImports.js'
import PayoutDetailsModal from "@/views/Commission/Hub/HubProfile/CenterProfileDetails/PayoutDetailsModalV2";
import mainEventBus from '@/assets/js/mainEventBus.js';
import { mapActions, mapState } from 'pinia'
import { useHubStore } from '@/stores/hubStore'

export default {
    props: ['hub_id'],
    mixins: [notifyFunctionMixin],
    components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    PayoutDetailsModal
},
    data() {
        return {
            tableData: [],
            sort_by: '',
            form: {},
            modals:{
                showDirectPayoutDetails: false,
            },
            current_view: [],
            decide_mode: false,
            permission: {
                acceptor: false,
                reviewer: false,
                approver: false
            },
            hub_team_id: null,
            comms_payout_summaries: [],
        }
    },
    computed: {
        ...mapState(useHubStore,['current_team', 'date_picked']),
    },
    watch: {
        async date_picked(newValue) {
            if(newValue)
            {
                const postData = {
                    'hub_id': this.hub_id,
                    'hub_team_id': this.hub_team_id,
                    'status': 'Pending',
                    'start_date': newValue[0],
                    'end_date': newValue[1],
                }

                try {
                    const res = await this.getCommsPayoutSummaryList(postData)
                    this.tableData = res.comms_payout_summaries
                } catch (error) {
                    // Handle any errors that might occur during the API call
                    console.error("Error fetching data:", error);
                }
            }
        },
    },
    async created() {
        if(this.$route.params.hub_team_id)
        {
            this.hub_team_id = this.$route.params.hub_team_id
        }

        const postData = {
            'hub_id': this.hub_id,
            'hub_team_id': this.hub_team_id,
            'status': 'Pending',
            'start_date': this.date_picked[0],
            'end_date': this.date_picked[1],
        }
        const res = await this.getCommsPayoutSummaryList(postData)
        this.tableData = res.comms_payout_summaries
    },  
    methods: {
        ...mapActions(useHubStore,['getCommsPayoutSummaryList']),
        openView(row) {
            this.modals.showDirectPayoutDetails = true;
            this.current_view = row;
            this.comms_payout_summaries = [row];
        },
        getStatusVariant(scope) {
            if(scope.row)
            {
                const status = scope.row.approval_status;
                if(status == 'Pending')
                {
                    return 'warning';
                }
                else if(status == 'Approved')
                {
                    return 'success';
                }
                else if(status == 'Rejected')
                {
                    return 'danger';
                }
                else
                {
                    return 'primary';
                }
            }
            return 'warning';
        },
    },
}
</script>